import { render, staticRenderFns } from "./bottomSelection.vue?vue&type=template&id=2f48ef53&scoped=true"
import script from "./bottomSelection.vue?vue&type=script&lang=js"
export * from "./bottomSelection.vue?vue&type=script&lang=js"
import style0 from "./bottomSelection.vue?vue&type=style&index=0&id=2f48ef53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48ef53",
  null
  
)

export default component.exports